import Header from "@/components/Header"

const AdminVestingManagementPage: React.FC = () => {
    return <>
        <Header />
        <div className="container mx-auto p-4 max-w-4xl">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Vesting Management</h1>
            </div>
        </div>
    </>
}

export default AdminVestingManagementPage